import { z } from 'zod';

/**
 * `GET /api/me/streamer`: se a conta e streamer da Grow uP no Stream Portal,
 * para a pagina da conta mostrar o atalho "O meu painel". `null` quando nao e
 * (ou saiu), ou com o portal desligado (`STREAM_PORTAL_ENABLED`).
 */
export const myStreamerLinkSchema = z.object({
  streamer: z.object({ status: z.enum(['active', 'paused']) }).nullable(),
});
export type MyStreamerLink = z.infer<typeof myStreamerLinkSchema>;

/**
 * `GET /api/streamers`: os streamers ativos da Grow uP para a pagina publica
 * `growup.gg/streamers`, quem esta no ar primeiro. Vem da streaming-api; sem
 * dados pessoais (so o nome de streamer e o canal). Vazio com o portal
 * desligado.
 */
export const siteStreamerSchema = z.object({
  /** Login na Twitch: o link e `twitch.tv/<channel>`. */
  channel: z.string(),
  displayName: z.string(),
  /** Imagem do canal na Twitch (so com a app da Twitch configurada). */
  avatarUrl: z.string().url().nullable(),
  /**
   * Foto de perfil da conta, se o streamer a autorizou (e e adulto): um
   * caminho do site (`/api/streamers/<canal>/foto.webp?v=...`). Tem prioridade
   * sobre a imagem da Twitch.
   */
  photoUrl: z.string().nullable(),
  /** Redes que o streamer escolheu mostrar, com o endereco publico. */
  links: z.array(
    z.object({
      network: z.enum(['youtube', 'instagram', 'x']),
      handle: z.string(),
      url: z.string().url(),
    }),
  ),
  /** O que transmite, da candidatura. */
  content: z.string().nullable(),
  /** A pagina publica do streamer (`/membros/<nickname>`), se a ativou. */
  pageUrl: z.string().nullable().default(null),
  /** No ar agora (so com a app da Twitch configurada). */
  live: z
    .object({
      title: z.string(),
      game: z.string().nullable(),
      viewers: z.number().int(),
      startedAt: z.string().datetime({ offset: true }),
    })
    .nullable(),
});
export type SiteStreamer = z.infer<typeof siteStreamerSchema>;
